import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  Checkbox,
  MenuItem,
  Button,
  Avatar,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import SearchNormal from "@assets/svg/search-normal.svg?react";
import PropertyImg from "@assets/svg/PropertyImg.svg?react";
import Sucessconnections from "@assets/svg/Sucessconnections.svg?react";
import CloseMenu from "@assets/svg/closeMenu.svg?react";

// ==============================
// LinkingBanner Section Styles
// ==============================

export const BannerSection = styled("section")<{ bgColor: string }>(
  ({ bgColor }) => ({
    backgroundColor: bgColor,
    borderRadius: 12,
    padding: 16,
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    marginBottom: 39,
  })
);

export const BannerContent = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 16,
  justifyContent: "center",
});

export const BannerText = styled("span")({
  fontSize: 14,
  fontWeight: 400,
  color: "#625783",
});

export const BannerSubText = styled("span")({
  color: "#5B3FFF",
});

export const BannerAction = styled("span")({
  fontSize: 14,
  fontWeight: 700,
  color: "#5B3FFF",
  cursor: "pointer",
});

// ==============================
// PropertyListHeader Styles
// ==============================

export const HeaderContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px solid #E9E9E7",
});

export const HeaderCheckboxContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flex: 1.3,
});

export const HeaderCheckbox = styled(Checkbox)({
  marginLeft: "8px",
  marginRight: "8px",
  "& .MuiSvgIcon-root": {
    color: "#CACACA",
  },
  "&.Mui-checked .MuiSvgIcon-root": {
    color: "#5B3FFF",
  },
  "&.MuiCheckbox-indeterminate .MuiSvgIcon-root": {
    color: "#5B3FFF",
  },
});

export const HeaderTitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginLeft: "16px",
  marginRight: "16px",
});

export const HeaderTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "14.4px",
  color: "#37352F",
});

export const HeaderColumn = styled(Typography)({
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "14.4px",
  color: "#37352F",
  flex: 1,
});

export const HeaderSpacer = styled(Box)({
  display: "flex",
  flex: 1,
});

// ==============================
// RenderPropertyItem Styles
// ==============================

export const PropertyItemContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  borderBottom: "1px solid #E9E9E7",
  paddingBottom: "15px",
  marginTop: "12px",
});

export const PropertyCheckboxContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flex: 1.3,
});

export const PropertyCheckbox = styled(Checkbox)({
  marginLeft: "8px",
  marginRight: "8px",
  "& .MuiSvgIcon-root": {
    color: "#CACACA",
  },
  "&.Mui-checked .MuiSvgIcon-root": {
    color: "#5B3FFF",
  },
});

export const PropertyImageContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
});

export const PropertyImage = styled("img")({
  width: "63px",
  height: "30px",
  borderRadius: "1.9px",
  marginLeft: "16px",
  marginRight: "16px",
});

export const PropertyTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "16.8px",
  color: "#331860",
  flex: 1,
});

export const PropertyLocation = styled(Typography)({
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "14.4px",
  color: "#000000",
  flex: 1,
});

export const PropertyChannelsContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flex: 1,
});

export const ChannelIcon = styled("div")<{ isActive?: boolean }>(
  ({ isActive = true }) => ({
    marginLeft: "10px",
    width: "24px",
    height: "24px",
    opacity: isActive ? 1 : 0.2,
  })
);

export const PropertyStatusContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  flex: 1,
});

export const PropertyActionContainer = styled(Box)({
  display: "flex",
  alignItems: "start",
  justifyContent: "center",
  width: 20,
  height: 21,
  borderRadius: 1,
  cursor: "pointer",
  flex: 1,
});

export const PropertyActionButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "20px",
  height: "21px",
  borderRadius: "4px",
  cursor: "pointer",
});

export const MenuTitle = styled(Typography)({
  fontWeight: 600,
  paddingLeft: "16px",
  paddingRight: "16px",
});

export const MenuActionItem = styled(MenuItem)({
  color: "#5A39D7",
  borderRadius: 1,
});

// ==============================
// LinkingStatus Styles
// ==============================

export const LinkingStatusContainer = styled("div")<{
  borderColor: string;
  bgColor: string;
}>(({ borderColor, bgColor }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  minWidth: "120px",
  width: "fit-content",
  height: "32px",
  background: bgColor,
  border: `1px solid ${borderColor}`,
  borderRadius: "9999px",
  textAlign: "center",
  paddingLeft: "12px",
  paddingRight: "12px",
}));

export const LinkingStatusDot = styled("span")<{ dotColor: string }>(
  ({ dotColor }) => ({
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: dotColor,
  })
);

export const LinkingStatusText = styled("span")({
  color: "#435363",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
});

// ==============================
// Syncing Component Styles
// ==============================

export const SyncingContainer = styled("section")({
  marginInline: "166px",
  marginTop: "33px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
});

export const SearchInputContainer = styled("span")({
  display: "flex",
  alignItems: "center",
  gap: "5px",
  padding: "8px",
  border: "1px solid #E5E7EB",
  borderRadius: "68px",
  width: "100%",
});

export const SearchIcon = styled(SearchNormal)({
  width: "15px",
  height: "15px",
});

export const SearchInput = styled("input")({
  border: "none",
  outline: "none",
  color: "#646E82",
});

export const PropertiesListContainer = styled("div")({
  width: "100%",
  border: "1px solid #E5E7EB",
  marginTop: "12px",
  borderRadius: "12px",
  padding: "16px",
});

export const ScrollableContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  padding: "16px",
  width: "100%",
  height: "400px",
  maxHeight: "346px",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "4px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#FAFAFA",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#D9D9D9",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#4a2fd9",
  },
});

export const PropertyItemWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "56px",
  borderBottom: "1px solid #E5E7EB",
  marginBottom: "12px",
});

export const PropertyItemLeft = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});

export const SyncingPropertyCheckbox = styled("input")({
  marginRight: "8px",
  width: "14px",
  height: "14px",
  accentColor: "#4a2fd9",
  borderRadius: "4px",
  border: "1px solid #E5E7EB",
});

export const SyncingPropertyImage = styled(PropertyImg)({
  width: "64px",
  height: "40px",
});

export const PropertyInfoContainer = styled("span")({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

export const SyncingPropertyTitle = styled("span")({
  fontSize: "12px",
  fontWeight: 700,
  color: "#331860",
});

export const SyncingPropertyLocation = styled("span")({
  fontSize: "10px",
  color: "#000000",
  fontWeight: 400,
});

export const PropertyItemRight = styled("div")({
  display: "flex",
  gap: "12px",
  alignItems: "center",
  justifyContent: "center",
});

export const SyncingStatusText = styled("span")({
  // Styles will be inherited from parent
});

export const ButtonContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
});

export const SyncingButton = styled("button")({
  width: 200,
  height: 46,
  borderRadius: 8,
  marginTop: "24px",
  backgroundColor: "#5B3FFF",
  color: "#fff",
  fontSize: "14px",
  fontWeight: 700,
  border: "none",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const FeaturesContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "24px",
  marginTop: "16px",
});

export const FeatureItem = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  textAlign: "center",
});

export const FeatureIcon = styled(Sucessconnections)({
  transform: "translateY(-2px)",
});

export const FeatureText = styled("span")({
  fontSize: "12px",
  fontWeight: 400,
  color: "#5B3FFF",
  textAlign: "center",
});

// ==============================
// DeactivateModal Component Styles
// ==============================

export const ModalContainer = styled("div")({
  width: "689px",
  backgroundColor: "rgba(255, 255, 255, 1)",
  color: "#261B6A",
  boxShadow: "0px 4px 24px rgba(0,0,0,0.08)",
  padding: "24px",
  borderRadius: "16px",
});

export const ModalWrapper = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
});

export const ModalHeaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
});

export const ModalTitle = styled(Typography)({
  color: "rgba(67, 83, 99, 1)",
  fontSize: "24px",
  fontWeight: 400,
  lineHeight: "28.8px",
  marginBottom: "24px",
});

export const CloseButton = styled(CloseMenu)({
  cursor: "pointer",
});

export const ChannelsTitle = styled(Typography)({
  color: "rgba(67, 83, 99, 1)",
  fontSize: "20px",
  fontWeight: 700,
  lineHeight: "25px",
  marginBottom: "16px",
});

// RenderSelect Component Styles
export const SelectContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "60px",
});

export const SelectLeftContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  flex: 1,
});

export const SelectAvatar = styled(Avatar)({
  backgroundColor: "lightBlue",
  width: 38,
  height: 38,
  marginLeft: "8px",
  marginRight: "8px",
});

export const SelectChannelName = styled(Box)({
  textAlign: "center",
  color: "rgba(67, 83, 99, 1)",
  fontSize: "18px",
  lineHeight: "22px",
});

export const SelectRightContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "54px",
});

export const StatusLabelContainer = styled(Box)<{ isActive: boolean }>(
  ({ isActive }) => ({
    width: "70px",
    height: "25px",
    borderRadius: "50px",
    fontSize: "14px",
    fontWeight: 400,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    backgroundColor: isActive ? "#F3FBF4" : "#FFFCF4",
    color: isActive ? "#16AE26" : "#FDBF21",
  })
);

export const StatusDot = styled(Box)<{ isActive: boolean }>(({ isActive }) => ({
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  backgroundColor: isActive ? "#16AE26" : "#FDBF21",
  marginRight: 0.5,
}));

export const ActionButton = styled(Button)<{ isActive: boolean }>(
  ({ isActive }) => ({
    width: "154px",
    height: "44px",
    borderRadius: "20px",
    fontSize: "16px",
    fontWeight: 700,
    textTransform: "none",
    minWidth: "154px",
    minHeight: "44px",
    backgroundColor: isActive
      ? "rgba(244, 67, 54, 0.1)"
      : "rgba(156, 39, 176, 0.1)",
    color: isActive ? "rgba(244, 67, 54, 1)" : "rgba(156, 39, 176, 1)",
    "&:hover": {
      backgroundColor: isActive
        ? "rgba(244, 67, 54, 0.1)"
        : "rgba(156, 39, 176, 0.1)",
      color: isActive ? "rgba(244, 67, 54, 1)" : "rgba(156, 39, 176, 1)",
      opacity: 0.8,
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.38)",
    },
  })
);

export const Divider = styled(Box)({
  height: "0.9px",
  width: "100%",
  backgroundColor: "rgba(233, 233, 233, 1)",
  marginTop: 1,
  marginBottom: 3,
});
